import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { FiberManualRecord } from '@material-ui/icons';
import Tooltip from '../../common/StyledToolTip';
import appConstant from "../../../appConstants";
import CheckViolation from "../../common/checkViolation";

const styles = theme => ({
    root:{
        paddingTop: '8px',

    },
    icon:{
        fontSize: '12px',
        color: theme.rowViolationDotColor,
    },
    iconNew:{
        fontSize: '12px',
        color: theme.HeaderSelectedText,
    },
    tooltipList:{
        listStyleType: 'none',
        padding: '0px',
        margin: '0px',
        fontSize:12
    }
});

function getViolationMessage (params, planDate ,dockCutoffTime) {
    let message = [];
    let isNewBillsViolation = false;
    if(params.colDef && params.colDef.gridTitle){
        switch(params.colDef.gridTitle){
            case appConstant.gridNames.RoutesGrid:

                if(CheckViolation.checkNewProsInRoute(params)){
                    message.push(CheckViolation.checkNewProsInRoute(params));
                    isNewBillsViolation = true;
                }else{
                    // message.push(CheckViolation.checkNumServiceViolation(params));
                    // message.push(CheckViolation.checkTrailerLiftGateViolation(params));
                    // message.push(CheckViolation.checkLoadCloseTimeGreaterThanStartTime(params));
                    // message.push(CheckViolation.checkEquipmentMatch(params))
                    // message.push(CheckViolation.checkClosedCustomerViolationForRouteStops(params.data));
                    message.push(...CheckViolation.getRouteViolationsFromEngine(params));
                }
                break;
            case appConstant.gridNames.StopsGrid:
                if(CheckViolation.checkNewProsInStop(params)){
                    message.push(CheckViolation.checkNewProsInStop(params));
                    isNewBillsViolation = true;
                }else{
                    message.push(CheckViolation.checkAppointmentMissed(params));
                    message.push(CheckViolation.checkPrepTimeGreaterThanStartTime({data: params.data, planDate: planDate}));
                    message.push(CheckViolation.checkEquipmentMatch(params));
                    message.push(CheckViolation.checkClosedCustomerViolation(params.data));
                }
                break;
            case appConstant.gridNames.IBShipmentsGrid:
                    message.push(
                      CheckViolation.checkIBETATimeGreaterThanDockCutOffTime(
                        params,
                        dockCutoffTime
                      )
                    );
                // if(CheckViolation.checkProIsNew(params)){                 commenting these checks for FFE
                //     message.push(CheckViolation.checkProIsNew(params));
                //     isNewBillsViolation = true;
                // }else{
                //     message.push(CheckViolation.checkRouteStartTimeViolation({data: params.data, planDate: planDate}));
                //     message.push(CheckViolation.checkLocationGeoCoded({data: params.data}));
                //     message.push(CheckViolation.checkClosedCustomerViolation(params.data));
                // }
                break;
            case appConstant.gridNames.DispatchedDriverGrid:
                if(CheckViolation.checkDriverHasDelayStops(params)){
                    message.push(CheckViolation.checkDriverHasDelayStops(params));
                }
                break;
            case appConstant.gridNames.CustomerGrid:
                if(CheckViolation.checkLocationGeoCoded({data: params.data})){
                    message.push(CheckViolation.checkLocationGeoCoded({data: params.data}));
                }
                break;
        }
    }
    message = message.filter(msg => msg);
    return { message, isNewBillsViolation}
};

function getPlanDate(params){
    if(params && params.agGridReact && params.agGridReact.props && params.agGridReact.props.userData && params.agGridReact.props.userData.userProfile){
        return params.agGridReact.props.userData.userProfile.planDate;
    }
    return null;
}

function getDockCutOffTime(params){
    if(params && params.agGridReact && params.agGridReact.props && params.agGridReact.props.userData && params.agGridReact.props.userData.userProfile){
        return params.agGridReact.props.userData.userProfile.terminal.dockCutOffTime;
    }
    return null;
}

function formatTooltip(messages, tooltipClass) {
    if(messages && messages.length > 0 ){
        const formattedMessage = messages.map((element, index) => (<li key={index}>{element}</li>));
        return (<ul className={tooltipClass}>{formattedMessage}</ul>);
    }
    return '';
}

const DotRenderer = params => {
    const { classes } = params;
    const {message, isNewBillsViolation} = getViolationMessage(params, getPlanDate(params),getDockCutOffTime(params));
    const formattedMessage = formatTooltip(message, classes.tooltipList);
    return (<div className={classes.root}>
        {
            message.length > 0 ? (<Tooltip title={formattedMessage}>
                                    <FiberManualRecord className={isNewBillsViolation ? classes.iconNew : classes.icon}/>
                                  </Tooltip>)
                                  : ''
        }
    </div>
    )
}

export default withStyles(styles)(DotRenderer);
